module.exports = __webpack_public_path__ + "static/media/loewy-cover.671c81f6.jpg";